module.exports = __webpack_public_path__ + "img/zxfw.f64e9488.png";